import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getCardTypeQr } from "../../page/FirstScreen/cardTypeQr";

const getValueUntilSecondSlash = (input) => {
  const parts = input.split("/");
  if (parts.length >= 3) {
    return `/${parts[1]}`;
  } else {
    return input;
  }
};

const Head = () => {
  const { lang, type, langBreadcrumbs, changeLang, pageCounter, cartTypeLang } =
    useSelector((state) => ({
      lang: state.changeLang.language.head,
      type: state.typeCard.type,
      langBreadcrumbs: state.changeLang.language.breadcrumbs,
      changeLang: state.changeLang.change,
      pageCounter: state.navigation.pageCounter,
      cartTypeLang: state.changeLang.language.cartType,
    }));

  const locale = changeLang === "en" ? "" : `/${changeLang}`;

  const initialBreadcrumbSchema = {
    "@context": "http://www.schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "WebPage",
          "@id": `${window.location.origin}${locale}/`,
          name: "ME-QR",
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "WebPage",
          "@id": `${window.location.origin}${locale}/qr-code-generator/`,
          name: langBreadcrumbs.type,
        },
      },
    ],
  };

  const { pathname } = useLocation();
  const path = useMemo(() => getValueUntilSecondSlash(pathname), [pathname]);
  const cardTypeQr = useMemo(() => {
    return getCardTypeQr(cartTypeLang);
  }, [cartTypeLang]);

  const [title, description] = getTitleDescription();
  const [breadcrumbSchema, setBreadcrumbSchema] = useState(
    initialBreadcrumbSchema
  );

  function getTitleDescription() {
    const title = lang[path]?.title
      ? lang[path].title
      : lang[path]?.h1
      ? `${lang[path].h1} ${lang.general.title[1]} ${lang[path].h1} ${lang.general.title[2]}`
      : lang.general.title[0];
    const description = lang[path]?.description
      ? lang[path].description
      : lang[path]?.t
      ? `${lang.general.description[1]} ${lang[path].t} ${lang.general.description[2]}`
      : lang.general.description[0];
    return [title, description];
  }

  useEffect(() => {
    const generalData = {
      "@type": "ListItem",
      position: 3,
      item: {
        "@type": "WebPage",
        "@id": window.location.href,
      },
    };

    if (pageCounter === 2) {
      setBreadcrumbSchema({
        ...initialBreadcrumbSchema,
        itemListElement: [
          ...initialBreadcrumbSchema.itemListElement,
          {
            ...generalData,
            item: {
              ...generalData.item,
              name: type
                ? `${cardTypeQr.find((item) => item.nav === type).title}`
                : "",
            },
          },
        ],
      });
    } else if (pageCounter === 3) {
      setBreadcrumbSchema({
        ...initialBreadcrumbSchema,
        itemListElement: [
          ...initialBreadcrumbSchema.itemListElement,
          {
            ...generalData,
            item: {
              ...generalData.item,
              name: langBreadcrumbs.customize,
            },
          },
        ],
      });
    } else {
      setBreadcrumbSchema(initialBreadcrumbSchema);
    }
  }, [pageCounter, type]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <link
        rel="canonical"
        href={`${window.location.origin}${window.location.pathname}`}
      />
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default Head;
